module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/Offers/player-8e6d9e1d037cd7725c84e6d116ea055e.png";